const StationSelectionMixin = {
	data() {
		return {
			filteredStations: [],
			favoriteStations: [],
			stationSearchTerm: null,
			stationsSearchTimeout: null,
			limit: 20,
			offset: 0,
			hasMore: false
		}
	},

	computed: {
		stations() {
			return this.$store.getters.getStations();
		},

		selectedStations: {
			get() {
				return this.$store.getters.getSelectedStations();
			},
			set(val) {
				this.$store.commit("addSelectedStations", val);
			}
		}
	},

	methods: {
		loadStations(offset = 0, forceLoad = false) {
			if (this.stationsSearchTimeout) {
				this.$worker.clearTimeout(this.stationsSearchTimeout);
			}

			if (!this.stationSearchTerm && this.filteredStations.length > 0 && offset === 0 && !forceLoad) {
				return;
			}

			this.stationsSearchTimeout = this.$worker.setTimeout(() => {
				this.offset = offset;

				if (this.offset === 0) {
					this.reInitializeData(true);
					if (this.selectedStation) {
						this.selectedStations = {
							StationID: this.selectedStation.StationID,
							StationName: this.selectedStation.StationName,
							Logo: this.selectedStation.Logo,
							logo: this.selectedStation.Logo
						};
					}
				}

				this.$store.dispatch(
						"searchStations",
						{
							search: this.stationSearchTerm ?? "", limit: this.limit, offset: this.offset,
							feature: this.panel?.params?.panelFeature
						}
					)
					.then(({filteredStations, hasMore, offset}) => {
						this.hasMore = hasMore;
						this.offset = offset;
						const favoriteIds = this.stations?.favorites || [];
						const selectedIds = this.selectedStations.map(s => s.StationID);

						if (!this.stationSearchTerm) {
							filteredStations.forEach(s => {
								// Make sure that the station has not already been loaded (as a favorite or selected), to avoid duplicates
								const isFavorite = favoriteIds.includes(s.id) ||
												   this.favoriteStations.some(fav => fav.id === s.id);
								const isSelected = selectedIds.includes(s.id);
								const isAlreadyFiltered = this.filteredStations.some(filtered => filtered.id === s.id);
								if (!isFavorite && !isSelected && !isAlreadyFiltered) {
									this.filteredStations.push(s);
								}
							});
						}
						else {
							// if user is searching for a station, empty the favoriteStations array
							// :items="selectedStations.concat(favoriteStations, filteredStations)" in station selector
							this.favoriteStations = [];
							filteredStations.forEach(station => {
								if (favoriteIds.includes(station.id)) {
									station.favorite = true;	// to display the star next to the station name
								}
								// Check if it's already in filteredStations (for pagination)
								if (!this.filteredStations.some(s => s.id === station.id)) {
									this.filteredStations.push(station);
								}
							});
						}
					})
					.catch(() => {
						this.$store.commit(
							"SHOW_NOTIFICATION_WITH_TYPE",
							{message: "An error occurred when trying to load the stations."}
						)
					});

				this.stationsSearchTimeout = null;
			}, 500);
		},

		reInitializeData(clearData) {
			const preloadedStationsCacheLimit = this.$store.getters.getUserObjectsCacheLimit();
			if (clearData) {
				this.favoriteStations = [];
			}
			const stationsData = !clearData &&
								 this.preloadStations &&
								 this.stations.data.length <= preloadedStationsCacheLimit ? this.stations.data : [];

			if (stationsData.length > 0 && !this.stationSearchTerm) {
				const favoriteIds = this.stations?.favorites || [];
				const selectedIds = this.selectedStations.map(s => s.StationID);
				this.filteredStations = stationsData.filter(s => !favoriteIds.includes(s.id) &&
																 !selectedIds.includes(s.id));
			}
			else {
				this.filteredStations = stationsData;
			}
			this.hasMore = false;
		},

		loadMore(isIntersecting) {
			if (isIntersecting) {
				this.loadStations(this.offset + this.limit);
			}
		}
	},

	watch: {
		stationSearchTerm(newVal, oldVal) {
			if (!newVal && oldVal) {
				this.loadStations(0, true);
			}
		}
	}
}

export default StationSelectionMixin;